import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  LANGUAGE_DROPDOWN_FEATURE_KEY,
  LanguageDropdownState,
  languageDropdownAdapter,
} from './language-dropdown.reducer';

// Lookup the 'LanguageDropdown' feature state managed by NgRx
export const selectLanguageDropdownState = createFeatureSelector<LanguageDropdownState>(
  LANGUAGE_DROPDOWN_FEATURE_KEY,
);

const { selectAll, selectEntities } = languageDropdownAdapter.getSelectors();

export const selectAllLanguageDropdown = createSelector(
  selectLanguageDropdownState,
  (state: LanguageDropdownState) => selectAll(state),
);

export const selectLanguageDropdownEntities = createSelector(
  selectLanguageDropdownState,
  (state: LanguageDropdownState) => selectEntities(state),
);

export const selectLanguageResponse = (dropdownId = '') =>
  createSelector(
    selectLanguageDropdownState,
    (state: LanguageDropdownState) => state.languageResponse[dropdownId || ''],
  );
